<template>
    <div class="dialogTips">
        <el-dialog
        title="提示信息"
        :visible.sync="DailogVisible"
        :before-close="TipsDiaClose"
        width="400px"
        class="dialog-tips"
        border
        >
            <div class="dialog-main">
                <ul class="tipsList">
                    <li v-for=" (item,index) in TipsInfo">{{(index+1)+'、'+item}}</li>
                </ul>
            </div>
            <div slot="footer" >
                <el-button v-no-more-click  type="primary" @click="TipsDiaClose" style=" margin-right:30px">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        data() {
            return {}
        },
        props:['DailogVisible','TipsInfo'],
        watch: {},
        computed: {

        },
        methods: {

//            关闭
            TipsDiaClose(){
                this.$emit( 'handleClose',false)
            }
        },
    }
</script>
<style lang="scss" scoped>
    .dialog-tips{
        /deep/ .el-dialog__body{
            padding-top: 0;
            padding: 10px 20px
        }
        /deep/ .el-dialog__header{
            border-bottom: 1px solid #D2D2D2;
        }
        /deep/ .el-dialog__footer{
            background:#f8f8f8;
            padding: 10px 0;
        }

        .dialog-main{
            width:100%;
            .tipsList{
                width:100%;
                max-height: 276px;
                overflow-y: auto;
                margin: 10px;
                li{
                    padding:0;margin:0;list-style:none;
                    font-size:14px;
                    line-height: 28px;
                }
            }
        }
    }
</style>